import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { ITwilioState } from 'entities/Calls/Twilio.models';
import { twilioReducers } from 'entities/Calls/Twilio.reducers';
import { twilioEffects } from 'entities/Calls/Twilio.effects';

export const twilio = createModel<IRootModel>()({
  state: {
    token: null,
    loading: false,
    onCall: false,
    duration: null,
  } as ITwilioState,
  reducers: twilioReducers,
  effects: twilioEffects,
});
